import apiService from "./api";

let treeCache = null;

/** Pretvara stablo u ravnu listu sa putanjom ("Piće › Vode") i dubinom, u redosledu stabla. */
export const flattenCategories = (tree, parentPath = "", depth = 0) =>
  (tree || []).reduce((list, node) => {
    const path = parentPath ? `${parentPath} › ${node.name}` : node.name;
    list.push({ id: node.id, name: node.name, path, depth, parent_id: node.parent_id, active: node.active });
    return list.concat(flattenCategories(node.children, path, depth + 1));
  }, []);

const productCategoryService = {
  /** Jedinstvene kategorije (stablo). Keširano dok se ne izmijene (`invalidate`). */
  async getTree(force = false) {
    if (!treeCache || force) {
      treeCache = apiService.get("/product-categories").then((res) => res.data);
      treeCache.catch(() => (treeCache = null));
    }
    return treeCache;
  },
  invalidate() {
    treeCache = null;
  },
  async create(payload) {
    const res = await apiService.post("/product-categories", payload);
    this.invalidate();
    return res;
  },
  async update(id, payload) {
    const res = await apiService.put(`/product-categories/${id}`, payload);
    this.invalidate();
    return res;
  },
  async remove(id) {
    const res = await apiService.delete(`/product-categories/${id}`);
    this.invalidate();
    return res;
  },
  /** Razvrstava više namirnica odjednom; categoryId = null skida kategoriju. */
  assign(groceryIds, categoryId) {
    return apiService.post("/product-categories/assign", { grocery_ids: groceryIds, category_id: categoryId });
  },
  getSupplierCategories(supplierId) {
    return apiService.get(`/suppliers/${supplierId}/categories`);
  },
  setSupplierCategories(supplierId, categoryIds) {
    return apiService.put(`/suppliers/${supplierId}/categories`, { category_ids: categoryIds });
  },
};

export default productCategoryService;
